import {FOUNDER} from '@/constants/roles'
import {uniqueId} from 'lodash'

const cacheTable = {
  columns: {
    getColumnsData: 'cacheColumnsData',
    setColumnsData: 'setCacheColumnsData'
  },
  rows: {
    getRowsData: 'cacheRowsData',
    setRowsData: 'setCacheRowsData'
  }
}

const columns = [
  {
    title: 'DATE OF PAYMENT',
    property: 'dateOfPayment',
    inputs: ['amountAED', 'creditAED'],
    editable: true,
    type: 'date',
    typeEditable: 'datePicker',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'CATEGORY',
    sortByColumn: true,
    inputs: ['amountAED', 'creditAED'],
    property: 'category',
    editable: true,
    typeEditable: 'select',
    listName: 'expensesCategory',
    list: [],
    categoryType: 1,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'CATEGORY 2',
    sortByColumn: true,
    inputs: ['amountAED', 'creditAED'],
    property: 'secondCategory',
    defaultProperty: 'secondCategory',
    editable: true,
    typeEditable: 'select',
    listName: 'expensesCategory',
    list: [],
    categoryType: 2,
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'DESCRIPTION',
    inputs: ['amountAED', 'creditAED'],
    property: 'paymentDescription',
    editable: true,
    regexp: /CN\/\d+\/BB-\d+./gmi,
    type: 'link',
    typeEditable: 'inputString'
  },
  {
    title: 'DEBIT',
    isNumber: true,
    onlyOne: 'creditAED',
    inputs: ['amountAED', 'creditAED'],
    property: 'amountAED',
    editable: true,
    typeEditable: 'inputNumber',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'CREDIT',
    isNumber: true,
    onlyOne: 'amountAED',
    inputs: ['amountAED', 'creditAED'],
    property: 'creditAED',
    editable: true,
    typeEditable: 'inputNumber',
    actions: {
      edit: true,
      delete: true
    }
  },
  {
    title: 'BALANCE',
    isNumber: true,
    inputs: ['amountAED', 'creditAED'],
    property: 'balanceAED'
  },
  {
    title: 'APPROVAL',
    editable: true,
    viewMode: 'checkbox',
    typeEditable: 'checkbox',
    inputs: ['amountAED', 'creditAED'],
    property: 'approved',
    center: true,
    access: [FOUNDER.id]
  },
  {
    property: 'action',
    inputs: ['amountAED', 'creditAED'],
    actions: {
      edit: true,
      delete: true
    },
    toolbar: {
      hideEditBtn: false,
      hideDeleteBtn: false,
      upload: true
    }
  }
]

const prefix = 'cash_register_column_'
const cacheTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  return col
})

export {cacheTable, cacheTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/cacheRegisrerTable.js